import { List, ListItemButton } from "@mui/material";
import { useLocation } from "react-router-dom";

import SidebarItem from "components/Navigation/SidebarItem";
import MenuIcon from "assets/icons/menu.svg?react";

import styles from "./Sidebar.module.css";

const Sidebar = ({ navItems, isExpanded, setIsExpanded }) => {
    const { pathname } = useLocation();

    return (
        <List
            className={`${styles.Sidebar} ${isExpanded ? "" : styles.collapsed}`}
            component="nav"
            data-testid="sidebar"
        >
            <ListItemButton
                className={styles.Sidebar_collapseButton}
                onClick={() => {
                    setIsExpanded(!isExpanded);
                }}
            >
                <MenuIcon />
            </ListItemButton>
            {navItems.map((item) => (
                <>
                    <SidebarItem
                        key={item.link}
                        label={item.label}
                        link={item.link}
                        icon={item.icon}
                        isExternal={item.isExternal}
                        isActive={
                            pathname === ""
                                ? item.link === "/"
                                : pathname.includes(
                                      item.label
                                          .toLowerCase()
                                          .replace(/\s+/g, ""),
                                  )
                        }
                        isExpanded={isExpanded}
                        hasSubItems={item.hasSubItems}
                        subItems={item.subItems}
                        subItemsLabel={item.subItemsLabel}
                    />
                </>
            ))}
            <div
                className={`${styles.Sidebar_Main_Overlap} ${isExpanded ? "" : styles.collapsed}`}
            >
                <div className={styles.Header_Curve} />
            </div>
        </List>
    );
};

export default Sidebar;
